module.exports = __webpack_public_path__ + "static/media/Cabinet1_After.a9124990.jpg";